import Color from '../../Color.js';
import input from '../input.js';
import { type } from '../../utils/index.js';
import w3cx11 from '../../colors/w3cx11.js';
import hex2rgb from '../hex/hex2rgb.js';
import rgb2hex from '../hex/rgb2hex.js';
Color.prototype.name = function () {
  var hex = rgb2hex(this._rgb, 'rgb');
  for (var _i = 0, _Object$keys = Object.keys(w3cx11); _i < _Object$keys.length; _i++) {
    var n = _Object$keys[_i];
    if (w3cx11[n] === hex) return n.toLowerCase();
  }
  return hex;
};
input.format.named = function (name) {
  name = name.toLowerCase();
  if (w3cx11[name]) return hex2rgb(w3cx11[name]);
  throw new Error('unknown color name: ' + name);
};
input.autodetect.push({
  p: 5,
  test: function test(h) {
    if (!(arguments.length <= 1 ? 0 : arguments.length - 1) && type(h) === 'string' && w3cx11[h.toLowerCase()]) {
      return 'named';
    }
  }
});